import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable react-hooks/exhaustive-deps */
import { Icon, toast } from '@livable/saas-react-components';
import { Button, Checkbox, FormControlLabel, FormGroup, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { track, events } from 'src/configs/amplitude';
import { useStore } from 'src/stores';
import useModalFooterStyles from 'src/styles/cutomModalFooter';
import { exportCSV } from 'src/utils/exportCSV';
import BillDetailsForm from './billDetailsForm';
import Comparison from './comparison';
import useStyles from './styles';
const BillDetails = observer(_ref => {
  var _property$allocations, _property$allocations4, _property$allocations5, _utility$bill1, _utility$bill10, _utility$billTotal, _utility$allocated, _utility$comparison, _utility$comparison2, _utility$comparison3, _utility$comparison4, _utility$comparison5, _utility$comparison6;
  let handleClose = _ref.handleClose,
    _ref$property = _ref.property,
    property = _ref$property === void 0 ? {} : _ref$property,
    showPreview = _ref.showPreview,
    isSubmeterUtility = _ref.isSubmeterUtility,
    onSubmeterBillSaved = _ref.onSubmeterBillSaved;
  const classes = useStyles();
  const modalFooterClasses = useModalFooterStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const page = 'Apply Billing';
  const currentCompany = store.homeDashboardStore.getCurrentCompany || {};
  const billingTab = currentCompany.billingTab;
  const applyBill = billingTab.applyBill || {};
  const billingCycleId = applyBill.billingCycleId;
  const isTableReady = applyBill.status === 'TableReady';
  const isStatementSent = applyBill.status === 'TableReadyStatementSent';
  const propertyId = property.id;
  const setApplyBillAutosave = billingTab.setApplyBillAutosave;
  const utilityId = applyBill.utilityId;
  const utility = ((_property$allocations = property.allocations) === null || _property$allocations === void 0 ? void 0 : _property$allocations.utilityById.get(billingCycleId + utilityId)) || {};
  const isReviewChecked = utility.isReviewChecked;
  const setReviewChecked = utility.setReviewChecked;
  const utilityAllocations = toJS(utility.allocations) || [];
  const sortedAllocations = utilityAllocations.sort((a, b) => {
    if (a.isBillable !== b.isBillable) return b.isBillable - a.isBillable;
    return a.unitName.localeCompare(b.unitName, undefined, {
      numeric: true
    });
  });
  const billableAllocations = sortedAllocations.filter(allocation => allocation.isBillable);
  const nonBillableAllocations = sortedAllocations.filter(allocation => !allocation.isBillable);
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showComparisonModal = _useState2[0],
    setShowComparisonModal = _useState2[1];
  const getAllocationComparison = async data => {
    const resp = await store.allocations.getAllocationComparisonAsync.run(data);
    return resp;
  };
  const postTableApproval = async data => {
    const resp = await store.allocations.postTableApprovalAsync.run(data);
    return resp;
  };
  const getAllocationTable = async data => {
    const resp = await store.allocations.getAllocationTableAggregateAsync.run(data);
    return resp;
  };
  const postReview = async data => {
    const resp = await store.allocations.postReviewAsync.run(data);
    return resp;
  };
  const getFileId = () => {
    var _property$allocations2, _property$allocations3, _utility$bill, _utility$bill2, _utility$bill3, _utility$bill4;
    return (_property$allocations2 = property.allocations) !== null && _property$allocations2 !== void 0 && (_property$allocations2 = _property$allocations2.tempFileData) !== null && _property$allocations2 !== void 0 && _property$allocations2.fileId ? (_property$allocations3 = property.allocations) === null || _property$allocations3 === void 0 || (_property$allocations3 = _property$allocations3.tempFileData) === null || _property$allocations3 === void 0 ? void 0 : _property$allocations3.fileId : (_utility$bill = utility.bill) !== null && _utility$bill !== void 0 && _utility$bill.redactedFileId ? (_utility$bill2 = utility.bill) === null || _utility$bill2 === void 0 ? void 0 : _utility$bill2.redactedFileId : (_utility$bill3 = utility.bill) !== null && _utility$bill3 !== void 0 && _utility$bill3.fileId ? (_utility$bill4 = utility.bill) === null || _utility$bill4 === void 0 ? void 0 : _utility$bill4.fileId : '';
  };

  // Bills API response (billId, propertyId, status, data, errors, createdAt, updatedAt) after posting file for automation
  const billAutomationResponse = (_property$allocations4 = (_property$allocations5 = property.allocations) === null || _property$allocations5 === void 0 || (_property$allocations5 = _property$allocations5.tempFileData) === null || _property$allocations5 === void 0 ? void 0 : _property$allocations5.billAutomationResponse) !== null && _property$allocations4 !== void 0 ? _property$allocations4 : null;
  const isBillExtractionEnabled = store.account.featureFlagsStore.getIsBillExtractionEnabled;
  const POLL_INTERVAL_MS = 5000;
  useEffect(() => {
    if (!isBillExtractionEnabled) return;
    let billId = billAutomationResponse === null || billAutomationResponse === void 0 ? void 0 : billAutomationResponse.billId;
    if (!billId || (billAutomationResponse === null || billAutomationResponse === void 0 ? void 0 : billAutomationResponse.status) !== 'Processing' && (billAutomationResponse === null || billAutomationResponse === void 0 ? void 0 : billAutomationResponse.status) !== 'Extracted') return;
    const poll = async () => {
      const resp = await store.billAutomationBillsApi.getBillAsync.run(billId);
      if (resp !== null && resp !== void 0 && resp.isSuccessful && resp !== null && resp !== void 0 && resp.response) {
        var _property$allocations6;
        (_property$allocations6 = property.allocations) === null || _property$allocations6 === void 0 || _property$allocations6.setTempFileData('billAutomationResponse', resp.response);
      }
    };
    const intervalId = setInterval(poll, POLL_INTERVAL_MS);
    poll();
    return () => clearInterval(intervalId);
  }, [isBillExtractionEnabled, billAutomationResponse === null || billAutomationResponse === void 0 ? void 0 : billAutomationResponse.billId, billAutomationResponse === null || billAutomationResponse === void 0 ? void 0 : billAutomationResponse.status]);
  const fileAttachedAsync = async () => {
    var _property$allocations7;
    let fileAttachedData = {};
    if ((_property$allocations7 = property.allocations) !== null && _property$allocations7 !== void 0 && (_property$allocations7 = _property$allocations7.tempFileData) !== null && _property$allocations7 !== void 0 && _property$allocations7.isDeleted) {
      var _utility$bill5;
      fileAttachedData = {
        billId: (_utility$bill5 = utility.bill) === null || _utility$bill5 === void 0 ? void 0 : _utility$bill5.id,
        fileId: null,
        isShared: false
      };
    } else if (getFileId()) {
      var _property$allocations8, _utility$bill6;
      if ((_property$allocations8 = property.allocations) !== null && _property$allocations8 !== void 0 && (_property$allocations8 = _property$allocations8.tempFileData) !== null && _property$allocations8 !== void 0 && _property$allocations8.isReducted || (_utility$bill6 = utility.bill) !== null && _utility$bill6 !== void 0 && _utility$bill6.redactedFileId) {
        var _utility$bill7, _utility$bill8, _utility$bill9, _property$allocations9;
        fileAttachedData = {
          billId: (_utility$bill7 = utility.bill) === null || _utility$bill7 === void 0 ? void 0 : _utility$bill7.id,
          fileId: (_utility$bill8 = utility.bill) !== null && _utility$bill8 !== void 0 && _utility$bill8.fileId ? (_utility$bill9 = utility.bill) === null || _utility$bill9 === void 0 ? void 0 : _utility$bill9.fileId : getFileId() ? getFileId() : '',
          redactedFileId: getFileId(),
          isShared: (_property$allocations9 = property.allocations) === null || _property$allocations9 === void 0 || (_property$allocations9 = _property$allocations9.tempFileData) === null || _property$allocations9 === void 0 ? void 0 : _property$allocations9.isShared
        };
      } else {
        var _utility$bill0, _property$allocations0;
        fileAttachedData = {
          billId: (_utility$bill0 = utility.bill) === null || _utility$bill0 === void 0 ? void 0 : _utility$bill0.id,
          fileId: getFileId(),
          isShared: (_property$allocations0 = property.allocations) === null || _property$allocations0 === void 0 || (_property$allocations0 = _property$allocations0.tempFileData) === null || _property$allocations0 === void 0 ? void 0 : _property$allocations0.isShared
        };
      }
    }
    if (fileAttachedData.billId) await store.allocations.getFileAttachedAsync.run(fileAttachedData);
  };
  const handleCheck = async () => {
    track(isReviewChecked ? events.disabled('Comparison Reviewed') : events.enabled('Comparison Reviewed'), {
      page,
      utility: applyBill.utilityName
    });
    if (!isReviewChecked) postReview({
      allocationCycleId: applyBill.allocationCycleId,
      billingCycleId,
      propertyId,
      utilityId,
      isReviewed: true
    }).then(() => getAllocationComparison({
      billingCycleId,
      propertyId,
      utilityId
    })).then(() => {
      setApplyBillAutosave(true);
      setTimeout(() => setApplyBillAutosave(false), 2000);
    });
    setReviewChecked(!isReviewChecked);
  };
  const handleEdit = () => {
    track(events.clicked('Edit Bill'), {
      page,
      utility: applyBill.utilityName
    });
    billingTab.setIsBillEdit(true);
  };
  const handleSave = async () => {
    track(events.clicked('Approve Table'), {
      page,
      utility: applyBill.utilityName
    });
    const savedBillingCycleId = billingCycleId;
    const savedUtilityId = utilityId;
    const savedAllocationCycleId = applyBill.allocationCycleId;
    billingTab.setIsModalLoading(true);
    postTableApproval({
      allocationCycleId: savedAllocationCycleId,
      billingCycleId: savedBillingCycleId,
      isApproved: true,
      isSkipped: false,
      propertyId,
      utilityId: savedUtilityId
    }).then(() => billingTab.updateBillingSummaryTimestamp()).then(() => {
      var _store$homeDashboardS;
      return billingTab.addToPreviewQueue({
        billingCycleId: savedBillingCycleId,
        id: savedBillingCycleId + propertyId,
        portfolioId: ((_store$homeDashboardS = store.homeDashboardStore.getCurrentPortfolio) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.id) || '',
        propertyId
      });
    }).then(() => fileAttachedAsync()).then(() => {
      var _billingTab$applyBill;
      if (((_billingTab$applyBill = billingTab.applyBill) === null || _billingTab$applyBill === void 0 ? void 0 : _billingTab$applyBill.utilityId) === savedUtilityId) {
        return getAllocationTable({
          billingCycleId: savedBillingCycleId,
          propertyId,
          utilityId: savedUtilityId
        });
      }
    }).then(() => {
      var _billingTab$applyBill2;
      if (((_billingTab$applyBill2 = billingTab.applyBill) === null || _billingTab$applyBill2 === void 0 ? void 0 : _billingTab$applyBill2.utilityId) === savedUtilityId) {
        var _property$allocations1;
        const updatedUtility = (_property$allocations1 = property.allocations) === null || _property$allocations1 === void 0 ? void 0 : _property$allocations1.utilityById.get(savedBillingCycleId + savedUtilityId);
        if (updatedUtility !== null && updatedUtility !== void 0 && updatedUtility.billStatus) {
          billingTab.setApplyBill(_objectSpread(_objectSpread({}, billingTab.applyBill), {}, {
            status: updatedUtility.billStatus
          }));
        }
      }
    }).then(() => toast('success', {
      body: ['Bill is successfully approved']
    })).finally(() => {
      var _billingTab$applyBill3;
      if (((_billingTab$applyBill3 = billingTab.applyBill) === null || _billingTab$applyBill3 === void 0 ? void 0 : _billingTab$applyBill3.utilityId) === savedUtilityId) {
        billingTab.setIsModalLoading(false);
      }
    });
  };
  const summaries = [{
    title: 'Service dates',
    value: "".concat(moment((_utility$bill1 = utility.bill) === null || _utility$bill1 === void 0 ? void 0 : _utility$bill1.startDateOnly).format('MM/DD/YYYY'), " - ").concat(moment((_utility$bill10 = utility.bill) === null || _utility$bill10 === void 0 ? void 0 : _utility$bill10.endDateOnly).format('MM/DD/YYYY'))
  }, {
    title: 'Bill amount',
    value: "$".concat((_utility$billTotal = utility.billTotal) === null || _utility$billTotal === void 0 ? void 0 : _utility$billTotal.toFixed(2))
  }, {
    title: 'Deductions',
    value: "".concat(utility.deductions, "%")
  }, {
    title: 'Total billing',
    value: "$".concat((_utility$allocated = utility.allocated) === null || _utility$allocated === void 0 ? void 0 : _utility$allocated.toFixed(2))
  }, {
    title: 'Recovery',
    value: "".concat(utility.recovery, "%")
  }];
  const getResidentName = residentAccountId => store.account.profilesFullName.get(residentAccountId) || t('allocations.not_enrolled');

  // Export bill details table to CSV
  const handleExportCSV = () => {
    track(events.clicked('Export Table To CSV'), {
      page,
      utility: applyBill.utilityName
    });
    const headers = ['Unit number', 'Resident Name', 'Billable', 'Number of occupants', 'Unit occupancy factor', 'Number of days', 'Utility total'];
    const rows = sortedAllocations.map(allocation => [allocation.unitName, getResidentName(allocation.residentAccountId), allocation.isBillable ? 'Yes' : 'No', allocation.occupantsCount, allocation.occupancyFactor, allocation.daysOccupied, allocation.allocationCharge.toFixed(2)]);
    exportCSV(headers, rows, 'bill_details.csv');
  };
  const sxData = {
    color: '#4B617C'
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, showPreview && !billingTab.isBillEdit ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: classes.infoAndEdit
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.infoWrapper
  }, summaries.map((summary, index) => /*#__PURE__*/React.createElement("dl", {
    key: index
  }, /*#__PURE__*/React.createElement("dt", null, summary.title), /*#__PURE__*/React.createElement("dd", null, summary.value)))), /*#__PURE__*/React.createElement("div", {
    className: ""
  }, !isStatementSent && /*#__PURE__*/React.createElement(Button, {
    disabled: !utility.isEditable,
    onClick: handleEdit,
    variant: "actionButton",
    'custom-attribute': '602-new-billing-module'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  }), "Edit"))), /*#__PURE__*/React.createElement("div", {
    className: classes.tableWrapper
  }, /*#__PURE__*/React.createElement(TableContainer, {
    sx: {
      maxHeight: showPreview && !isStatementSent && (_utility$comparison = utility.comparison) !== null && _utility$comparison !== void 0 && _utility$comparison.isBillIncreasedBy20Percent && !((_utility$comparison2 = utility.comparison) !== null && _utility$comparison2 !== void 0 && _utility$comparison2.isReviewed) ? 400 : 560,
      overflow: 'auto'
    }
  }, /*#__PURE__*/React.createElement(Table, {
    stickyHeader: true
  }, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    align: "left"
  }, "Unit number"), /*#__PURE__*/React.createElement(TableCell, {
    align: "left"
  }, "Resident Name"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, "Number of occupants"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, "Unit occupancy factor"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, "Number of days"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, "Utility total"))), /*#__PURE__*/React.createElement(TableBody, null, (() => {
    return [...billableAllocations.map((allocation, index) => /*#__PURE__*/React.createElement(TableRow, {
      key: "billable-".concat(index)
    }, /*#__PURE__*/React.createElement(TableCell, {
      align: "left"
    }, allocation.unitName), /*#__PURE__*/React.createElement(TableCell, {
      align: "left"
    }, getResidentName(allocation.residentAccountId)), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, allocation.occupantsCount), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, allocation.occupancyFactor), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, allocation.daysOccupied), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, "$", allocation.allocationCharge.toFixed(2)))), ...(nonBillableAllocations.length > 0 ? [/*#__PURE__*/React.createElement(TableRow, {
      key: "separator",
      sx: {
        color: '#4B617C',
        position: 'sticky',
        top: 53,
        zIndex: 9
      }
    }, /*#__PURE__*/React.createElement(TableCell, {
      align: "center",
      colSpan: 6,
      sx: {
        backgroundColor: '#f5f5f5',
        color: '#4B617C',
        lineHeight: '1px'
      }
    }, "The following residents are not billable yet"))] : []), ...nonBillableAllocations.map((allocation, index) => /*#__PURE__*/React.createElement(TableRow, {
      key: "non-billable-".concat(index),
      sx: {
        backgroundColor: '#f5f5f5',
        color: '#4B617C'
      }
    }, /*#__PURE__*/React.createElement(TableCell, {
      align: "left",
      sx: sxData
    }, allocation.unitName), /*#__PURE__*/React.createElement(TableCell, {
      align: "left",
      sx: sxData
    }, getResidentName(allocation.residentAccountId)), /*#__PURE__*/React.createElement(TableCell, {
      align: "right",
      sx: sxData
    }, allocation.occupantsCount), /*#__PURE__*/React.createElement(TableCell, {
      align: "right",
      sx: sxData
    }, allocation.occupancyFactor), /*#__PURE__*/React.createElement(TableCell, {
      align: "right",
      sx: sxData
    }, allocation.daysOccupied), /*#__PURE__*/React.createElement(TableCell, {
      align: "right",
      sx: sxData
    }, "$", allocation.allocationCharge.toFixed(2))))];
  })()))))), /*#__PURE__*/React.createElement("div", null, showPreview && !isStatementSent && (_utility$comparison3 = utility.comparison) !== null && _utility$comparison3 !== void 0 && _utility$comparison3.isBillIncreasedBy20Percent && !((_utility$comparison4 = utility.comparison) !== null && _utility$comparison4 !== void 0 && _utility$comparison4.isReviewed) ? /*#__PURE__*/React.createElement("div", {
    className: classes.warningBlock
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.warningBlockData
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, "Your allocation amount has increased by more than 20% since last time."), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, "Please review the comparison between the current and previous allocations and check the checkbox below."), /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: isReviewChecked,
      onChange: handleCheck
    }),
    label: "I reviewed the comparison with the previous cycles."
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.warningBlockAction
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButtonInvert",
    onClick: () => {
      track(events.clicked('Review Comparison'), {
        page,
        utility: applyBill.utilityName
      });
      setShowComparisonModal(true);
    },
    'custom-attribute': '603-new-billing-module'
  }, "Review comparison")), showComparisonModal && utility.comparison ? /*#__PURE__*/React.createElement(Comparison, {
    comparison: utility.comparison,
    setShowComparisonModal: setShowComparisonModal
  }) : null) : null, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.modalFooterStandartSmall
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: () => {
      track(events.clicked('Close'), {
        page,
        utility: applyBill.utilityName
      });
      handleClose();
    },
    variant: "text",
    'custom-attribute': '605-new-billing-module'
  }, t('general.close')), /*#__PURE__*/React.createElement(Button, {
    onClick: handleExportCSV,
    size: "small",
    variant: "contained",
    'custom-attribute': '699-new-billing-module'
  }, "Export table to CSV")), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerButton
  }, !isStatementSent && /*#__PURE__*/React.createElement(Button, {
    disabled: ((_utility$comparison5 = utility.comparison) === null || _utility$comparison5 === void 0 ? void 0 : _utility$comparison5.isBillIncreasedBy20Percent) && !((_utility$comparison6 = utility.comparison) !== null && _utility$comparison6 !== void 0 && _utility$comparison6.isReviewed) && !isReviewChecked && !isTableReady || !utility.isEditable,
    onClick: handleSave,
    type: "button",
    variant: "contained",
    'custom-attribute': '604-new-billing-module'
  }, t('Approve table')))))))) : /*#__PURE__*/React.createElement(BillDetailsForm, {
    billAutomationResponse: isBillExtractionEnabled ? billAutomationResponse : null,
    handleClose: handleClose,
    showPreview: showPreview,
    utility: utility,
    isSubmeterUtility: isSubmeterUtility,
    onSubmeterBillSaved: onSubmeterBillSaved
  }));
});
export default BillDetails;